// /Frontend/hoppla-admin/src/components/ui/Button.tsx
import type { ButtonHTMLAttributes, PropsWithChildren } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger' | 'success';
}

export function Button({ variant = 'primary', className = '', children, ...props }: PropsWithChildren<ButtonProps>): JSX.Element {
  return (
    <button {...props} className={`button button--${variant} ${className}`.trim()}>
      {children}
    </button>
  );
}
